import { useEffect, useReducer, useState, useRef } from 'react';
import DesktopContext, { reducerIntialState, reducer } from './common/DesktopContext';
import NProgress from 'nprogress';
import config from './common/config';
import useSlidenav from '../hooks/useSlidenav';
import useResize from '../hooks/useResize';
import Header from './Header';

import './styles/App.less';

NProgress.set(0.25);
NProgress.inc(0.2);
function App() {
  const [state, dispatch] = useReducer(reducer, reducerIntialState);
  const slidesRef: any = useRef();
  const [nextSeq, handlers] = useSlidenav(slidesRef, dispatch, state);
  const [isLandscape] = useResize(state.scale, state.baseWidth);
  const [loadInfo, setLoadInfo]: any = useState({});

  useEffect(() => {
    if (config.debug) {
      const $title: any = document.querySelector('title');
      $title.innerHTML = `Slide ${nextSeq}@Aurum`;
    }
  }, [nextSeq]);

  useEffect(() => {
    if (loadInfo[nextSeq]) {
      NProgress.done();
      NProgress.remove();
    } else {
      NProgress.start();
    }
  }, [loadInfo, nextSeq]);

  return (
    <DesktopContext.Provider
      value={{
        state,
        dispatch,
      }}
    >
      <div {...handlers}>
        <Header />
        <div className={`desktop app ${isLandscape ? 'app-landscape' : 'app-portrait'}`}>
          {/* {config.debug && <div className="debug">Slide「{nextSeq}」</div>} */}
          <section className="slides" ref={slidesRef} data-seq={nextSeq}>
            {config.slides.slice(nextSeq, nextSeq + 2).map((slide: any, offset: number) => {
              const seq = nextSeq + offset;
              slide.videos = slide.videos || [];
              const Slide = slide.component;
              return (
                <Slide
                  seq={seq}
                  key={seq}
                  show={nextSeq === seq}
                  onDataLoaded={(seqLoaded: any) => {
                    loadInfo[seqLoaded] = true;
                    setLoadInfo({ ...loadInfo });
                  }}
                />
              );
            })}
          </section>
        </div>
      </div>
    </DesktopContext.Provider>
  );
}

export default App;
